import React from "react";
import { connect } from "../i18n/connect";
import {
  clearValidationError,
  registerRoutine
} from "../redux/modules/auth/register";
import {
  authCheckboxLabelClassName,
  authCheckboxLabelStyle,
  authCheckboxLabelTagsStyles
} from "../lib/auth/authCheckboxLabelStyles";
import { authEmailInputProps } from "../lib/auth/authAutofillHints";
import withFormBuilder from "./withFormBuilder";
import {
  getRegisterLoading,
  getRegisterValidationErrors
} from "../redux/modules/auth/register/selector";
import { getUserData } from "../redux/modules/auth/login/selector";
import config from "../config/";

export default function withRegisterForm(WrappedComponent) {
  const mapStateToProps = state => ({
    userData: getUserData(state),
    registerLoading: getRegisterLoading(state),
    validationErrors: getRegisterValidationErrors(state)
  });

  const mapDispatchToProps = {
    // The routine itself is trigger action creator
    register: registerRoutine.trigger,
    clearValidationError
  };

  const fields = [
    {
      name: "email",
      label: "E-mail",
      type: "newText",
      required: true,
      fullWidth: true,
      validations: {
        isEmail: true
      },
      validationErrors: {
        isEmail: "Your email seems to be invalid",
        isDefaultRequiredValue: "This field is required"
      },
      value: "",
      ...authEmailInputProps,
      wrapperClassName: "mb-4 md:mb-6",
      nativeStyles: { marginBottom: 32 }
    },
    {
      name: "all_agreements",
      type: "newCheckbox-group",
      fields: ["terms", "personal_data_processing", "marketing_emails"],
      label: "Select all agreements",
      wrapperClassName: "mb-2",
      nativeStyles: { marginBottom: 8 },
      labelClassName: authCheckboxLabelClassName,
      labelStyle: authCheckboxLabelStyle,
      labelTagsStyles: authCheckboxLabelTagsStyles
    },
    {
      name: "terms",
      selected: [],
      type: "newCheckbox",
      required: true,
      validationErrors: {
        isTrue: "This field is required"
      },
      options: [
        {
          label: "Terms and conditions agreement",
          value: "terms",
          translateData: {
            termsAndConditionsUrl: config.termsAndConditionsUrl,
            privacyPolicyUrl: config.privacyPolicyUrl
          }
        }
      ],
      wrapperClassName: "mb-2",
      nativeStyles: { marginBottom: 8 },
      labelClassName: authCheckboxLabelClassName,
      labelStyle: authCheckboxLabelStyle,
      labelTagsStyles: authCheckboxLabelTagsStyles
    },
    {
      name: "personal_data_processing",
      selected: [],
      type: "newCheckbox",
      options: [
        {
          label: "Personal data processing agreement",
          value: "personal_data_processing",
          expands: true,
          expandedLabel: "Personal data processing agreement expanded"
        }
      ],
      wrapperClassName: "mb-2",
      nativeStyles: { marginBottom: 8 },
      labelClassName: authCheckboxLabelClassName,
      labelStyle: authCheckboxLabelStyle,
      labelTagsStyles: authCheckboxLabelTagsStyles
    },
    {
      name: "marketing_emails",
      selected: [],
      type: "newCheckbox",
      options: [
        {
          label: "Electronic communication agreement",
          value: "marketing_emails",
          expands: true,
          expandedLabel: "Electronic communication agreement expanded"
        }
      ],
      wrapperClassName: "mb-2",
      nativeStyles: { marginBottom: 8 },
      labelClassName: authCheckboxLabelClassName,
      labelStyle: authCheckboxLabelStyle,
      labelTagsStyles: authCheckboxLabelTagsStyles
    }
  ];

  @connect(mapStateToProps, mapDispatchToProps)
  @withFormBuilder(fields)
  class WithRegisterForm extends React.Component {
    state = {};

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithRegisterForm;
}
